import imgAnalisa from '../../assets/image/gagal_analisa.png';
import imgProduk from '../../assets/image/img-produk-2.png';
import iconWarning from '../../assets/icon/icon-warning.svg';
import iconChevronUp from '../../assets/icon/icon_chevron_up.svg';
import { useState } from 'react';

const HasilAnalisaGagal = (props) => {
  const [showDetail, setShowDetail] = useState(true);

  return (
    <div className="flex-grow flex flex-col justify-center items-center w-full my-5 md:my-14 md:px-10">
      <div className="">
        <img
          src={imgAnalisa}
          className="w-full object-contain rounded-xl"
          alt="hasil analisa"
        />
      </div>
      <div className=" flex flex-none md:max-w-[450px] text-textGray mt-10">
        <p className="text-center">
         Hasil tidak dapat di proses silahkan coba kembali
        </p>
      </div>
    </div>
  );
};

export default HasilAnalisaGagal;
